<div *ngIf="broadcast && skinReady"
     id="layer-container"
     [ngClass]="skinCssClass"
     [class.setup]="isSetup"
     [class.fullscreen]="fullscreenBroadcast"
>
  <app-status [broadcast]="broadcast"
              [game]="game"
              [manual]="broadcast.config.manualStatus"
              [controlAction]="broadcastService.getControlAction(controls, 'status', singleComponent)">
  </app-status>
  <app-followed-games [broadcast]="broadcast"
                      [game]="game"
                      *ngIf="game"
                      [controlAction]="broadcastService.getControlAction(controls, 'relatedGames', singleComponent)">
  </app-followed-games>

  <app-batter [broadcast]="broadcast"
              [player]="game?.currentBatter"
              [controlAction]="broadcastService.getControlAction(controls, 'batter', singleComponent)">
  </app-batter>
  <app-lower-third [broadcast]="broadcast"
                   [controlAction]="broadcastService.getControlAction(controls, 'lowerThird', singleComponent)">
  </app-lower-third>
  <app-pitcher [broadcast]="broadcast"
               [game]="game"
               [controlAction]="broadcastService.getControlAction(controls, 'pitcher', singleComponent)">
  </app-pitcher>
  <app-box-score [broadcast]="broadcast"
                 [game]="game"
                 [controlAction]="broadcastService.getControlAction(controls, 'boxScore', singleComponent)">
  </app-box-score>
  <app-lineup [broadcast]="broadcast"
              [game]="game"
              [awayCtrl]="broadcastService.getControlAction(controls, 'awayLineup', singleComponent)"
              [homeCtrl]="broadcastService.getControlAction(controls, 'homeLineup', singleComponent)"
  >
  </app-lineup>
  <img alt="static partner logo" id="tipsport-logo" src="assets/logos/tipsport200.png" *ngIf="broadcastService.getControlAction(controls, 'staticPartner', singleComponent) != 'off'" />
  <iframe id="tipsport-rti" src="https://tipsportaffiliate.com/banner/rti/baseball/banner.php?d=300x720" *ngIf="broadcastService.getControlAction(controls, 'tipsportRti', singleComponent) != 'off'" title="Tipsport RTI"></iframe>
  <app-defense [broadcast]="broadcast"
               [game]="game"
               [home]="true" *ngIf="broadcastService.getControlAction(controls, 'homeDefense', singleComponent) === 'on'"></app-defense>
  <app-defense [broadcast]="broadcast"
               [game]="game"
               [home]="false" *ngIf="broadcastService.getControlAction(controls, 'awayDefense', singleComponent) === 'on'"></app-defense>
  <app-intro [broadcast]="broadcast"
             [game]="game"
             [ctrl]="broadcastService.getControlAction(controls, 'intro', singleComponent)"></app-intro>
  <app-power-by [ctrl]="broadcastService.getControlAction(controls, 'poweredBy', singleComponent)"></app-power-by>
  <app-custom-table [broadcast]="broadcast" [controlAction]="broadcastService.getControlAction(controls, 'customTable', singleComponent)"></app-custom-table>
  <app-partner-logos [league]="league"
                     [control]="broadcastService.getControl(controls, 'partnerLogos')"></app-partner-logos>
</div>
